import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import electrocution from '../../images/electrocution.png';

import {CSVLink} from "react-csv";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";


class ChecklistEletrico extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);


        this.showDiv19= this.showDiv19.bind(this);
        this.showDiv20= this.showDiv20.bind(this);
        this.showDiv21= this.showDiv21.bind(this);
        this.showDiv22= this.showDiv22.bind(this);
        this.showDiv23= this.showDiv23.bind(this);
        this.showDiv24= this.showDiv24.bind(this);
        this.showDiv25= this.showDiv25.bind(this);


        this.state ={
        showComponent19: false, /*choque eletrico*/
            showComponent20: false,
            showComponent21: false,
            showComponent22: false,
            showComponent23: false,
            showComponent24: false,
            showComponent25: false,

            data: [
                { pergunta: "Os interruptores principais estão desenergizados, bloqueados e sinalizados com etiquetas antes de iniciar um trabalho em circuitos de energia, para que ninguém mais possa usá-los enquanto outro estiver trabalhando?", resposta: "Sim ou não"},
                { pergunta: "Inspeções elétricas periódicas são feitas por pessoas qualificadas?", resposta: "Sim ou não"},
                { pergunta: "Apenas pessoas qualificadas trabalham em reparos elétricos e utiliza instrumentos adequados para testar circuitos?", resposta: "Sim ou não"},
                { pergunta: "Fiação, equipamentos, cabos e plugues estão em boas condições e aterrados?"
                    , resposta: "Sim ou não" },
                { pergunta: "Os trabalhadores estão cientes do procedimento em caso de contato acidental com linhas de energia?", resposta: "Sim ou não"},
                { pergunta: "O sistema elétrico tem ampla capacidade de lidar com todas as cargas?", resposta: "Sim ou não"},
                { pergunta: "Todos os interruptores elétricos têm um dispositivo de bloqueio para evitar partida acidental do equipamento durante a manutenção?", resposta: "Sim ou não"},
            ],


        }

    }

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };

    /***choque elétrico***/

    showDiv19 = (e) => {
        this.setState({
            showComponent19: e.target.checked,
        });
    };

    showDiv20 = (e) => {
        this.setState({
            showComponent20: e.target.checked,
        });
    };

    showDiv21 = (e) => {
        this.setState({
            showComponent21: e.target.checked,
        });
    };

    showDiv22 = (e) => {
        this.setState({
            showComponent22: e.target.checked,
        });
    };


    showDiv23 = (e) => {
        this.setState({
            showComponent23: e.target.checked,
        });
    };

    showDiv24 = (e) => {
        this.setState({
            showComponent24: e.target.checked,
        });
    };

    showDiv25 = (e) => {
        this.setState({
            showComponent25: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };

    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});

        return(
            <Card>

                <Row>
                    <div className={"text-center"} align="center">
                        <img src={electrocution} className={"img"} alt={"Aquasafe logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>

                <div id={"printDiv"}>
                <div align={"center"}>
                <h5><b><FormattedMessage id={"elec.ch"} defaultMessage={"Checklist Choque Elétrico"}/></b></h5>
                </div>
                <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>

                <div className={"margin"}>
                    <b><FormattedMessage id={"elec.ch"} defaultMessage={"Checklist Choque Elétrico"}/></b></div>

                <div className={"electric1"}>

                    <form action={"#"} className={"formsWorks"}>

                        <p><FormattedMessage id={"elec.ch1"} defaultMessage={"Os interruptores principais estão desenergizados, bloqueados e sinalizados com etiquetas antes de iniciar um trabalho em circuitos de energia, para que ninguém mais possa usá-los enquanto outro estiver trabalhando?"}/>

                        </p>

                        <input type={"checkbox"} id={"yes19"}/>

                        <label htmlFor={"yes19"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no19"} onClick={this.showDiv19}/>

                            <label htmlFor={"no19"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent19 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                    </form>
                </div>

                <div className={"electric2"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch2"} defaultMessage={"Inspeções elétricas periódicas são feitas por pessoas qualificadas?"}/>
                        </p>

                        <input type={"checkbox"} id={"yes20"}/>

                        <label htmlFor={"yes20"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no20"} onClick={this.showDiv20}/>

                            <label htmlFor={"no20"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent20 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"electric3"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch3"} defaultMessage={"Apenas pessoas qualificadas trabalham em reparos elétricos e utiliza instrumentos adequados para testar circuitos?"}/></p>

                        <input type={"checkbox"} id={"yes21"}/>

                        <label htmlFor={"yes21"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no21"} onClick={this.showDiv21}/>

                            <label htmlFor={"no21"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent21 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"electric4"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch4"} defaultMessage={"Fiação, equipamentos, cabos e plugues estão em boas condições e aterrados?"}/></p>

                        <input type={"checkbox"} id={"yes22"}/>

                        <label htmlFor={"yes22"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no22"} onClick={this.showDiv22}/>

                            <label htmlFor={"no22"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent22 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"electric5"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch5"} defaultMessage={"Os trabalhadores estão cientes do procedimento em caso de contato acidental com linhas de energia?"}/>

                        </p>

                        <input type={"checkbox"} id={"yes23"}/>

                        <label htmlFor={"yes23"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no23"} onClick={this.showDiv23}/>

                            <label htmlFor={"no23"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent23 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                    </form>
                </div>

                <div className={"electric6"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch6"} defaultMessage={"O sistema elétrico tem ampla capacidade de lidar com todas as cargas?"}/></p>

                        <input type={"checkbox"} id={"yes24"}/>

                        <label htmlFor={"yes24"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no24"} onClick={this.showDiv24}/>

                            <label htmlFor={"no24"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent24 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"electric7"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"elec.ch7"} defaultMessage={"Todos os interruptores elétricos têm um dispositivo de bloqueio para evitar partida acidental do equipamento durante a manutenção?"}/>
                        </p>

                        <input type={"checkbox"} id={"yes25"}/>

                        <label htmlFor={"yes25"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                            <input type={"checkbox"} id={"no25"} onClick={this.showDiv25}/>

                            <label htmlFor={"no25"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent25 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                    </form>
                </div>
                </div>

                <br/>

                <Button className={"button"} onClick={this.handleDownloadPDF} >
                    PDF
                </Button>


                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                        CSV
                    </Button> </CSVLink>

            </Card>
        )}

}

export default injectIntl(ChecklistEletrico);